import { useEffect, useState } from "react"
import { LG_BREAKPOINT } from "../constants/breakpoints.js"

export default function useIsMobileViewport(breakpoint = LG_BREAKPOINT) {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined") {
            return false
        }
        return window.innerWidth < breakpoint
    })

    useEffect(() => {
        function syncIsMobile() {
            const next = window.innerWidth < breakpoint
            setIsMobile((prev) => (prev === next ? prev : next))
        }

        window.addEventListener("resize", syncIsMobile)
        return () => window.removeEventListener("resize", syncIsMobile)
    }, [breakpoint])

    return isMobile
}

